<div if.bind="admin.showLogin" class="modal-overlay" click.trigger="admin.cancelLogin()">
  <form class="login-modal" submit.trigger="admin.submitLogin()" click.trigger="$event.stopPropagation()">
    <h3 class="login-modal__title">Admin sign in</h3>
    <label class="login-field">
      <span>Username</span>
      <input type="text" value.bind="admin.loginUsername" autocomplete="username" disabled.bind="admin.loggingIn" />
    </label>
    <label class="login-field">
      <span>Password</span>
      <input type="password" value.bind="admin.loginPassword" autocomplete="current-password" disabled.bind="admin.loggingIn" />
    </label>
    <div if.bind="admin.loginError" class="login-error">${admin.loginError}</div>
    <div class="login-actions">
      <button type="button" class="login-btn login-btn--secondary" click.trigger="admin.cancelLogin()" disabled.bind="admin.loggingIn">Cancel</button>
      <button type="submit" class="login-btn login-btn--primary" disabled.bind="admin.loggingIn || !admin.loginUsername || !admin.loginPassword">
        ${admin.loggingIn ? 'Signing in…' : 'Sign in'}
      </button>
    </div>
  </form>
</div>
